export function generateRandomAlphanumericString() {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersArray: string[] = [];
  const length = 48;

  for (let i = 0; i < length; i++) {
    charactersArray.push(
      characters.charAt(Math.floor(Math.random() * characters.length))
    );
  }

  return charactersArray.join('');
}
